/**
 * meta 可配置参数
 * @param {boolean} icon 页面icon
 * @param {boolean} keepAlive 是否缓存页面
 * @param {string} title 页面标题
 */
export default [
  {
    path: '/more',
    name: 'more',
    component: () => import('@/views/more/more.vue'),
  },
  {
    path: '/myActivity',
    name: 'myActivity',
    component: () => import('@/views/myActivity/myActivity.vue'),
  },
  {
    path: '/activityDetail',
    name: 'activityDetail',
    component: () => import('@/views/activityDetail/activityDetail.vue'),
  },
  {
    path: '/signUp',
    name: 'signUp',
    component: () => import('@/views/signUp/signUp.vue'),
  },
  {
    path: '/memberList',
    name: 'memberList',
    component: () => import('@/views/memberList/memberList.vue'),
  },
  {
    path: '/checkstand',
    name: 'checkstand',
    component: () => import('@/views/checkstand/checkstand.vue'),
  },
  {
    path: '/showResult',
    name: 'showResult',
    component: () => import('@/views/showResult/showResult.vue'),
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/views/agreement/agreement.vue'),
  },
  {
    path: '/waiting',
    name: 'waiting',
    component: () => import('@/views/waiting/waiting.vue'),
  },
  {
    title: '门口驿站',
    path: '/download',
    name: 'download',
    component: () => import('@/views/download/download.vue'),
  },
  {
    title: '开具发票',
    path: '/issueInvoice',
    name: 'issueInvoice',
    component: () => import('@/views/invoice/issueInvoice/issueInvoice.vue'),
  },
  {
    title: '设置发票抬头',
    path: '/setInvoiceTitle/:type',
    name: 'setInvoiceTitle',
    component: () => import('@/views/invoice/setInvoiceTitle/setInvoiceTitle.vue'),
  },
  {
    title: '更多内容',
    path: '/invoiceMore',
    name: 'invoiceMore',
    component: () => import('@/views/invoice/invoiceMore/invoiceMore.vue'),
  },
  {
    title: '开票记录',
    path: '/invoiceRecord',
    name: 'invoiceRecord',
    component: () => import('@/views/invoice/invoiceRecord/invoiceRecord.vue'),
  }
]
